import { postJson } from "../methods";
function updateUserCompanyLimits_default(lookup, headers = {}) {
  return postJson({
    url: `api/user/company/limit/${lookup.toLowerCase()}`,
    headers
  });
}
export {
  updateUserCompanyLimits_default as default
};
